module.exports = __webpack_public_path__ + "static/media/02eb1dd7.jpg";